/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Error_Create_Set_LogInputs */



/**
* | output |
* | --- |
* | "Error writing new set:" |
*
* @param {Tags_Manager_Error_Create_Set_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_create_set_log = /** @type {((inputs?: Tags_Manager_Error_Create_Set_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Create_Set_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la creation de l'ensemble :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Schreiben des neuen Sets:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante la scrittura del nuovo set:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при записи нового набора данных:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al escribir el nuevo conjunto:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("写入新数据集时出错：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいセットの書き込み中にエラーが発生しました:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया सेट लिखने में त्रुटि:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao escrever novo conjunto:")
	return /** @type {LocalizedString} */ ("Error writing new set:")
});